import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ThemeManagerService {

    constructor() { }
    
    public setWebTheme(themeName: string) {

        document.body.classList.add(themeName);
        
    }

}
